import type { VideoSeries } from '@/types'

export const videoSeriesList: VideoSeries[] = [
    {
        id: 'sq',
        anchor: 'shqip',
        navLabel: 'Shqip',
        title: 'Abetarja Kuranore',
        intro:
            'Mësoni shkronjat arabe, shqiptimin dhe lidhjen e tyre në fjalë përmes shpjegimeve dhe ushtrimeve praktike. Ndiqini mësimet sipas radhës dhe përsëritni ushtrimet përpara se të kaloni te mësimi vijues.',
        playlistUrl: 'https://www.youtube.com/playlist?list=PLHcER7hPiWzQYkp6wnd7wnIqHcFSmfl3N',
        bookSlug: 'abetarja-kuranore',
        hasPromo: true,
        videos: [
            { id: "x-naz5kn66E", title: "Promo" },
            { id: "cNCgoK2xxFQ", title: "Hyrje" },
            { id: "1p5hVyZHZt8", title: "Shkronjat: Baa' dhe Taa'" },
            { id: "mqY7d_vF3NI", title: "Shkronjat: Thaa' dhe Xhiim" },
            { id: "7S5Tzj1Setk", title: "Shkronjat: Ḥaa' dhe Ḣââ'" },
            { id: "nWJ96MIlCyM", title: "Shkronjat: Elif dhe Daal" },
            { id: "xlFd8Y3b8Vg", title: "Shkronjat: Dhaal dhe Rââ'" },
            { id: "wX8fI6DKeeM", title: "Shkronjat: Zaaj dhe Waaw" },
            { id: "5HXOVBKL1UU", title: "Shkronjat: Siin dhe Shiin" },
            { id: "zkjxysVUTEs", title: "Shkronjat: Ṣââd dhe Ḍââd" },
            { id: "FLkl52uyiAY", title: "Shkronjat: Ṭââ' dhe Ḍhââ'" },
            { id: "xb0BpvGXA9Q", title: "Shkronjat: Ӑjn dhe Ġajn" },
            { id: "eOyZX5ofn4Y", title: "Shkronjat: Faa' dhe Ḳââf" },
            { id: "E9VMLL-74DA", title: "Shkronjat: Kaaf dhe Laam" },
            { id: "qYYt4Zl7IHQ", title: "Shkronjat: Miim dhe Nuun" },
            { id: "ZccsMPaEhOo", title: "Shkronjat: Haa' dhe Jaa'" },
            { id: "0X_oF6_wdhI", title: "Tenvini" },
            { id: "Y-jG8vAfiy0", title: "Sukuni" },
            { id: "wxxdpdaHzH0", title: "Teshdidi" },
            { id: "w_5XhE5_k4U", title: "Hemzeja" },
            { id: "VzNN6nISLIA", title: "A-ja e gjatë" },
            { id: "ZNyTSHeKnmA", title: "I-ja e gjatë dhe U-ja e gjatë" },
            { id: "xr3C-XwFpes", title: "Lidhja e fjalëve" },
            { id: "q5AEDg189w8", title: "Rënia e zgjatimeve" },
            { id: "g2UFfBzxIBs", title: "Shqiptimi i fjalës Allah" },
            { id: "0EJHPH8_4ew", title: "Hemzetul-vasli" },
            { id: "OS0Gn_Z7lAQ", title: "Ngjashmëria e shkronjave" },
            { id: "RZtiBu5-zCM", title: "Rregulla për leximin e Kuranit" }
        ]
    },
    {
        id: 'en',
        anchor: 'anglisht',
        navLabel: 'Anglisht',
        title: 'The Quranic Primer',
        intro:
            'A structured journey through the letters of the Qur’an, taught with clarity and patience. Each lesson builds on the one before, guiding the learner from first acquaintance with the letters to fluent reading.',
        playlistUrl: 'https://www.youtube.com/playlist?list=PLHcER7hPiWzTUcL-JsY6ok3mOlLJdsNWA',
        bookSlug: 'the-quranic-primer',
        hasPromo: false,
        videos: [
            { id: "XeQ53JTcqBA", title: "Introduction" },
            { id: "TJ_hu6TzTCI", title: "Baa' & Taa'" },
            { id: "G9aKsC5Jj4Q", title: "Thaa' & Jeem" },
            { id: "fxsfNzlz8qI", title: "Ḥaa' & Khaa'" },
            { id: "_mShmxa_8V0", title: "Alif & Daal" },
            { id: "OWpr2YSgEb8", title: "Dhaal & Raa'" },
            { id: "aarNpL2L5Fc", title: "Zaay & Waaw" },
            { id: "oYFm0i7W-E4", title: "Seen & Sheen" },
            { id: "g1ITkalBHFg", title: "Ṣaad & Ḍaad" },
            { id: "kU7AxeiCD9k", title: "Ṭaa' & Ḍhaa'" },
            { id: "3gFcqekwnyg", title: "'Ayn & Ghayn" },
            { id: "t9FAekIPlDU", title: "Faa' & Qaaf" },
            { id: "sOqA4YybQgU", title: "Kaaf & Laam" },
            { id: "6tMVivICPEs", title: "Meem & Noon" },
            { id: "6w5EtkRhTzE", title: "Haa' & Yaa'" },
            { id: "F60BcI3HcPA", title: "Tanween" },
            { id: "5djoVhYFRY0", title: "Sukoon" },
            { id: "AtF-wYbGuxM", title: "Shadda" },
            { id: "-N_je8geCvc", title: "Hamza" },
            { id: "IAGqh8DwI34", title: "Elongations – Fatḥa" },
            { id: "HwsmRek0UrE", title: "Elongations – Kasra & Ḍamma" },
            { id: "hb2ujMVQhuo", title: "Connecting words" },
            { id: "gwddd6qX67o", title: "Dropping the elongations" },
            { id: "MbAgik9bBOk", title: "Pronouncing the word Allah" },
            { id: "xT9qgo8FDEA", title: "Hamzatul-Wasl" },
            { id: "KvbfldWP5qo", title: "Similar letters" },
            { id: "kRIzOfPKZLo", title: "Rules of Qur'an recitation" }
        ]
    },
    {
        id: 'de',
        anchor: 'gjermanisht',
        navLabel: 'Gjermanisht',
        title: 'Koran lesen lernen – Das quranische Alphabet (Anfängerkurs)',
        intro:
            'Ein strukturierter Weg durch die Buchstaben des Korans, vermittelt mit Klarheit und Geduld. Jede Lektion baut auf der vorherigen auf und führt vom ersten Kennenlernen der Buchstaben bis zum flüssigen Lesen.',
        playlistUrl: 'https://www.youtube.com/playlist?list=PLHcER7hPiWzS9eMZdJnUyH3WSRsmJeJiG',
        bookSlug: 'das-quranische-alphabet',
        hasPromo: true,
        videos: [
            { id: "34Z6i4CgfDU", title: "Promo" },
            { id: "NZvZllTE3sA", title: "Einführung" },
            { id: "iuoJLA5yV4w", title: "Baa' & Taa'" },
            { id: "oZHmfBDfiBc", title: "Thaa' & Ğiim" },
            { id: "VGcejoTthXU", title: "Ḥaa' & Ḣââ'" },
            { id: "wVS3hX2Tw-E", title: "Alif & Daal" },
            { id: "voyrbZ3vVeA", title: "Dhaal & Rââ'" },
            { id: "q0th5rwqKlE", title: "Zaay & Waaw" },
            { id: "nbTF8Ssk5XY", title: "Siin & Shiin" },
            { id: "fiJZcGkMEOg", title: "Ṣââd & Ḍââd" },
            { id: "FQ2wobrNcR8", title: "Ṭââ' & Ḍhââ'" },
            { id: "3qGZTv7NjWg", title: "Ӑyn & Ġayn" },
            { id: "b7KAqfAxr0Y", title: "Faa' & Qââf" },
            { id: "EbPzq2sc6B0", title: "Kaaf & Laam" },
            { id: "-sKziVwpZsM", title: "Miim & Nuun" },
            { id: "0-NwiyCpLtY", title: "Haa' & Jaa'" },
            { id: "jDcfHa92ZQw", title: "Tanween" },
            { id: "AbKDHNK7tVI", title: "Sukun" },
            { id: "CGu0igSVCk0", title: "Schadda" },
            { id: "bWplh5nR738", title: "Hamsa" },
            { id: "nQzt5Ta6zjA", title: "Verlängerungen – Fatḥa" },
            { id: "-Savhu6pdKM", title: "Verlängerungen – Kassra & Ḍamma" },
            { id: "j0v7Q1wjNl0", title: "Das Verbinden der Wörter" },
            { id: "5PqtISBA8_o", title: "Unterlassung der Vokalverlängerung" },
            { id: "F-55HtfCBlE", title: "Die Aussprache des Wortes Allah" },
            { id: "V5BczY0ivZo", title: "Hamsatul-Wasl" },
            { id: "m2tGNVZeX1A", title: "Ähnlichkeiten bei Buchstaben" },
            { id: "fze3co_nj5c", title: "Regeln zur Quran-Rezitation" }
        ]
    }
]
